import Model from './Model'

export default class News extends Model {

	static entity = 'news'
	static endpoint = '/cms/news'

	static fields () {
		return {
			id: this.attr(),
			title: this.string(),
			postDate: this.string(),
			leadImage: this.string(),
			url: this.string()
		}
	}

}



// WEBPACK FOOTER //
// ./src/store/models/News.js